<template>
  <div class="text-hireful relative p-2 border-2 rounded-lg focus-within:border-hireful flex items-center justify-center flex-wrap w-full">
    <input type="search" autocomplete="off" id="autoCompleteInput" class="block appearance-none focus:outline-none bg-transparent w-full" v-model="searchText" :placeholder="label" @keydown="showSearchResult" @click="showSearchResult" :style="dropDownArrowStyle" v-click-outside="onClickOutside" />
    <transition name="fade">
      <div class="absolute w-full shadow leading-tight focus:outline-none focus:shadow-outline z-50 boxShadow3x" v-if="showResult"
      :class="{'mt-64': filteredList.length >= 3, 'mt-48': filteredList.length === 2, 'mt-24': filteredList.length <= 1}">
        <div class="max-h-52 overflow-auto shadow-2xl" v-if="filteredList.length">
          <template v-for="ats in filteredList">
            <div :key="`ats-${ats.ats_id}`" @click="selectItem(ats)" class="px-4 py-2 border-b flex w-full justify-start cursor-pointer hover:bg-gray-200 bg-white">
              <div class="flex flex-wrap text-hireful">
                <div class="flex w-full text-base hireful-font-semibold text-left font-bold">
                  {{ats.organisation_name}}
                </div>
                <div class="flex w-full text-xs italics text-hireful" v-if="getCompanyTypeText(ats.company_type)">
                  {{getCompanyTypeText(ats.company_type)}}
                </div>
                <div class="flex w-full text-xs text-hireful">
                  {{ats.role_type}}
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="max-h-52 overflow-auto shadow-2xl" v-else>
          <div class="px-4 py-2 border-b flex w-full justify-center cursor-pointer hover:bg-gray-200 bg-white">
            No result found
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
// import hirefulIcon from '@/components/hireful-icon'

export default {
  name: 'autocomplete',
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    // hirefulIcon
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    label: {
      type: String,
      default: 'Search'
    }
  },
  data () {
    return {
      searchText: '',
      showResult: false
    }
  },
  computed: {
    filteredList () {
      const vm = this
      if (vm.itemText === '') {
        return this.options
      } else {
        return this.options.filter(o => o[vm.itemText].toLowerCase().includes(this.searchText.toLowerCase()))
      }
    },
    dropDownArrowStyle () {
      return { background: 'url(' + require('@/assets/images/icons/arrow_drop_down.png') + ') no-repeat right', backgroundSize: '32px' }
    }
  },
  watch: {
    showResult (val) {
      this.$emit('active', val)
    }
  },
  methods: {
    selectItem (item) {
      this.searchText = item.organisation_name
      this.$emit('selected', item)
      this.showResult = false
    },
    showSearchResult () {
      this.showResult = true
    },
    onClickOutside () {
      this.showResult = false
    }
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s cubic-bezier(.06,.92,.62,.86);
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#autoCompleteInput::-webkit-search-cancel-button{
    position:relative;
    right:25px;
}

::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  font-size: 0.75rem;
}
::-moz-placeholder { /* Firefox 19+ */
  font-size: 0.75rem;
}
:-ms-input-placeholder { /* IE 10+ */
  font-size: 0.75rem;
}
:-moz-placeholder { /* Firefox 18- */
  font-size: 0.75rem;
}
</style>
